import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@air/primitive-button";
import { memo } from "react";
import { useDiscussionPanelContext } from "~/components/AssetModal/shared/context/DiscussionsPanelContext/DiscussionsPanelContext";
import { DISCUSSION_COMMENT_ADD_REPLY } from "~/constants/testIDs";
export const ReplyButton = /*#__PURE__*/ memo((param)=>{
    let { discussionId } = param;
    const { setReplyingDiscussionId } = useDiscussionPanelContext();
    return /*#__PURE__*/ _jsx(Button, {
        appearance: "ghost",
        color: "grey",
        "data-testid": DISCUSSION_COMMENT_ADD_REPLY,
        onClick: (event)=>{
            event.stopPropagation();
            setReplyingDiscussionId(discussionId);
        },
        size: "small",
        children: "Reply"
    });
});
ReplyButton.displayName = "ReplyButton";
